import React from 'react';
import {colors} from 'src/assets';
import {StyleSheet, Text, View, StyleProp, ViewStyle} from 'react-native';
import LocalText from 'src/local';

export enum BannerLayout {
  WaitingAnswer,
  AnswerRequired,
  WaitingTalkConnectionBySender,
  WaitingTalkConnectionByReceiver,
  TalkTime,
  TalkRemain,
}

export type BannerProps = {
  containerStyle?: StyleProp<ViewStyle>;
  layout: BannerLayout;
  countDown?: string;
  time?: string;
  maxTime?: string;
};

export const Banner: React.FC<BannerProps> = ({
  containerStyle,
  layout,
  countDown,
  time,
  maxTime,
}) => {
  return (
    <React.Fragment>
      {layout === BannerLayout.WaitingAnswer && (
        <View style={[styles.root, containerStyle]}>
          <View style={styles.statusContainer}>
            <Text style={styles.statusText}>
              {LocalText.screens.call.banner.waitingAnswerStatus}
            </Text>
          </View>
          <View style={styles.detailContainer}>
            <View style={styles.leftTimeContainer}>
              <Text style={styles.leftTimeText} adjustsFontSizeToFit={true}>
                {countDown}
              </Text>
            </View>
            <View style={styles.waitingTimeContainer}>
              <Text style={styles.waitingTimeLabel}>
                {LocalText.screens.call.banner.waitingAnswerLabel}
              </Text>
              <Text style={styles.waitingTimeText}>{maxTime}</Text>
            </View>
          </View>
        </View>
      )}
      {layout === BannerLayout.AnswerRequired && (
        <View style={[styles.root, containerStyle]}>
          <View style={styles.statusContainer}>
            <Text style={styles.statusText}>
              {LocalText.screens.call.banner.answerRequiredStatus}
            </Text>
          </View>
          <View style={styles.detailContainer}>
            <View style={styles.leftTimeContainer}>
              <Text style={styles.leftTimeText} adjustsFontSizeToFit={true}>
                {countDown}
              </Text>
            </View>
            <View style={styles.waitingTimeContainer}>
              <Text style={styles.waitingTimeLabel}>
                {LocalText.screens.call.banner.answerRequiredLabel}
              </Text>
              <Text style={styles.waitingTimeText}>{maxTime}</Text>
            </View>
          </View>
        </View>
      )}
      {layout === BannerLayout.WaitingTalkConnectionBySender && (
        <View style={[styles.root, containerStyle]}>
          <View style={[styles.statusContainer, styles.statusContainerGreen]}>
            <Text style={[styles.statusText, styles.statusTextGreen]}>
              {
                LocalText.screens.call.banner
                  .waitingTalkConnectionBySenderStatus
              }
            </Text>
          </View>
        </View>
      )}
      {layout === BannerLayout.WaitingTalkConnectionByReceiver && (
        <View style={[styles.root, containerStyle]}>
          <View style={[styles.statusContainer, styles.statusContainerGreen]}>
            <Text style={styles.statusText}>
              {
                LocalText.screens.call.banner
                  .waitingTalkConnectionByReceiverStatus
              }
            </Text>
          </View>
          {/* <View style={styles.detailContainer}>
            <View style={styles.leftTimeContainer}>
              <Text style={styles.leftTimeText} adjustsFontSizeToFit={true}>
                {countDown}
              </Text>
            </View>
            <View style={styles.waitingTimeContainer}>
              <Text style={styles.waitingTimeLabel}>最大待ち時間</Text>
              <Text style={styles.waitingTimeText}>{maxTime}</Text>
            </View>
          </View> */}
        </View>
      )}
      {layout === BannerLayout.TalkTime && (
        <View style={[styles.root, containerStyle]}>
          <View style={styles.statusContainer}>
            <Text style={styles.statusText}>
              {LocalText.screens.call.banner.talkTimeStatus}
            </Text>
          </View>
          <View style={styles.detailContainer}>
            <View style={styles.leftTimeContainer}>
              <Text style={styles.leftTimeText} adjustsFontSizeToFit={true}>
                {time}
              </Text>
            </View>
            <View style={styles.waitingTimeContainer}>
              <Text style={styles.waitingTimeLabel}>
                {LocalText.screens.call.banner.talkTimeLabel}
              </Text>
              <Text style={styles.waitingTimeText}>{maxTime}</Text>
            </View>
          </View>
        </View>
      )}
      {layout === BannerLayout.TalkRemain && (
        <View style={[styles.root, containerStyle]}>
          <View style={styles.statusContainer}>
            <Text style={styles.statusText}>
              {LocalText.screens.call.banner.talkRemainStatus}
            </Text>
          </View>
          <View style={styles.detailContainer}>
            <View style={styles.leftTimeContainer}>
              <Text
                style={[styles.leftTimeText, styles.leftTimeTextRed]}
                adjustsFontSizeToFit={true}>
                {countDown}
              </Text>
            </View>
          </View>
        </View>
      )}
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  root: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: colors.chokuGray12,
    borderRadius: 4,
    flexDirection: 'row',
    minHeight: 50,
  },
  statusContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  statusContainerGreen: {
    justifyContent: 'center',
  },
  statusText: {
    fontSize: 12,
    fontWeight: 'bold',
    color: colors.chokuBlack,
  },
  statusTextGreen: {
    fontSize: 13,
    color: colors.chokuGreen,
  },
  detailContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: 160,
  },
  leftTimeContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  leftTimeText: {
    fontSize: 30,
    fontWeight: 'bold',
    color: colors.chokuGreen,
  },
  leftTimeTextRed: {
    color: colors.chokuRed,
  },
  waitingTimeContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  waitingTimeLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: colors.chokuBlack,
  },
  waitingTimeText: {
    fontSize: 11,
    fontWeight: 'bold',
    color: colors.chokuGreen,
    marginTop: 2,
  },
});
